import React from 'react';
import {
  Card,
  Col,
  Row,
  Typography,
  Collapse,
  Checkbox,
  Button,
  Switch,
  Tooltip,
} from 'antd';
import { CaretRightOutlined, EditOutlined } from '@ant-design/icons';
import { mapSnakeCaseToSpaceCase } from '@/utils/mapper';
import PropertyFormModal from '@/pages/property/components/PropertyFormModal';

const { Text } = Typography;
const { Panel } = Collapse;

interface PersonalPropertyCardProps {
  property: {
    propertyDetails: Record<string, any>;
    propertyLocation: string;
    id: string | number;
  };
  defaultOpen?: boolean;
  onSelect?: (propertyId: string | number, selected: boolean) => void;
  isSelected?: boolean;
  showCheckbox?: boolean;
  overseas?: boolean;
  refetchPropertyData?: () => void;
  formSource?: string;
}

const PersonalPropertyCard: React.FC<PersonalPropertyCardProps> = ({
  property,
  defaultOpen,
  onSelect,
  isSelected = false,
  showCheckbox = false,
  overseas = false,
  refetchPropertyData,
  formSource,
}) => {
  const { propertyDetails, propertyLocation, id } = property;
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleCheckboxChange = (e: any) => {
    if (onSelect) {
      onSelect(id, e.target.checked);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <Collapse
      defaultActiveKey={defaultOpen ? [id] : []}
      style={{
        backgroundColor: 'white',
      }}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
    >
      <Panel
        header={
          <div style={{ width: '100%' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                rowGap: 8,
                borderBottom: '1px solid #555',
                paddingBottom: 8,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <Typography.Text
                  style={{
                    fontSize: '15px',
                    fontWeight: 500,
                    color: '#000',
                  }}
                >
                  {propertyDetails?.property_address}
                </Typography.Text>
              </div>
              <Tooltip title="Edit Property">
                <Button
                  type="link"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsModalOpen(true);
                  }}
                  style={{
                    color: '#222',
                    backgroundColor: '#fafafa',
                  }}
                >
                  <EditOutlined />
                </Button>
              </Tooltip>
            </div>

            {showCheckbox && (
              <div
                style={{
                  marginTop: 8,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <Typography.Text>
                  Assign to Assessment Application
                </Typography.Text>
                <Tooltip title="Toggle to assign property to Assessment Application">
                  <Switch
                    checked={isSelected}
                    onChange={(checked) => {
                      if (onSelect) {
                        onSelect(id, checked);
                      }
                    }}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        }
        key={id}
      >
        <Row
          gutter={[16, 16]}
          style={{
            padding: '0 20px',
          }}
        >
          {Object.entries(propertyDetails ?? {}).map(([key, value]) => {
            if (key !== 'property_address_object') {
              return (
                <Col key={key} span={12}>
                  <Typography.Text style={{ margin: '0' }}>
                    <Text strong>{mapSnakeCaseToSpaceCase(key)}: </Text>
                    <Text>
                      {typeof value === 'boolean'
                        ? value
                          ? 'Yes'
                          : 'No'
                        : value
                          ? mapSnakeCaseToSpaceCase(value)
                          : ('' as React.ReactNode)}
                    </Text>
                  </Typography.Text>
                </Col>
              );
            }
          })}
        </Row>
      </Panel>
      <PropertyFormModal
        isModalOpen={isModalOpen}
        closeModal={handleModalClose}
        overseas={overseas}
        propertyOption="personal"
        id={id}
        type="edit"
        refetchPropertyData={refetchPropertyData}
        formSource={formSource}
      />
    </Collapse>
  );
};

export default PersonalPropertyCard;
